<template>
  <div class="py-3 container-fluid space-y-4">

    <!-- Header usuario y fechas -->
    <div class="bg-white rounded-xl shadow-md p-3">
      <div class="flex flex-col md:flex-row md:items-center gap-3">
        <!-- Usuario -->
        <div class="flex items-center gap-3 w-full">
          <img :src="acreditado && acreditado.foto ? acreditado.foto : require('@/assets/img/nologo.png')" class="shadow-sm w-16 rounded-lg" />
          <div class="flex flex-col">
            <h5 class="text-xl font-bold mb-1 text-slate-800">{{ acreditado ? acreditado.nombre + " " +
              acreditado.apellido : $t('label.cargando') }}</h5>
            <p class="mb-0 text-xs text-slate-500">{{ $t('label.fecha.alta') }} : {{ acreditado ?
              formatDate(acreditado.fechaAlta, 'dd/MM/yyyy HH:mm:ss') : $t('label.cargando') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin header usuario y fechas -->


    <!-- Mensajes -->
    <div class="bg-white rounded-xl shadow-md">

      <div class="p-3 mb-2 space-y-2">
        <h6 class="text-lg font-bold text-slate-800">{{ $t('menu.mensajes') }}</h6>
      </div>

      <ul class="divide-y divide-gray-200 list-none pb-4">
        <li @click="mostrarConversacion(item)" v-for="(item, i) in mensajesFiltrados" :key="i"
          class="hover:bg-gradient-to-r from-gray-200 to-gray-50 cursor-pointer">
          <div class="flex items-center gap-3 py-2 mx-3">
            <div class="h-16 w-16 rounded-lg shadow-xl flex items-center justify-center border">
              <font-awesome-icon :icon="getIcono(item)" class="text-2xl" />
            </div>

            <div class="flex-1 text-left">
              <div class="text-xs font-semibold text-gray-700">{{ formatDate(item.fechaAlta, 'dd/MM/yyyy hh:mm:ss') }}</div>

              <div v-if="item.acreditadoDe.id === acreditado.id" class="text-sm md:text-lg font-semibold uppercase text-gray-700">{{ item.acreditadoPara.nombre + ' ' + item.acreditadoPara.apellido }}</div>
              <div v-else class="text-sm md:text-lg font-semibold uppercase text-gray-700">{{ item.acreditadoDe.nombre + ' ' + item.acreditadoDe.apellido }}</div>

              <div class="text-xs line-clamp-1" >{{ $t(item.mensaje) }}</div>
            </div>

            <div class="relative">
              <font-awesome-icon :icon="['far', 'fa-eye']" class="text-2xl mr-2 text-gray-500" />
            </div>
          </div>
        </li>
      </ul>

    </div>
    <!-- Fin Mensajes -->

  </div>

  <DetalleMensajesView v-if="detalleConversacionVisible" :closeFunction="closeDialogConversacion" :acreditado="acreditado" :mensaje="mensajeSeleccionado" />

  <FullScreenLoader :visible="isSubmitting" />

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2'

import DetalleMensajesView from './modal/DetalleMensajesView.vue';
import FullScreenLoader from '@/components/commons/FullScreenLoader.vue';

import { formatDate } from '@/utils/formatters';

import { Acreditado, ConfiguracionMeeting, Evento, MensajeMeeting } from "qreventos-suite/src/services/suite.interfaces";
import seguridadServices from "@/services/seguridad.services";
import meetingService from "qreventos-suite/meeting";
import configuracionMeetingService from '@/services/configuracion.merting.services';

export default defineComponent({
  components: {
    FullScreenLoader,
    DetalleMensajesView
  },
  data() {
    return {
      isSubmitting: false,
      acreditado: undefined as unknown as Acreditado,
      mensajes: [] as MensajeMeeting[],
      mensajesFiltrados: [] as MensajeMeeting[],
      detalleConversacionVisible: false,
      mensajeSeleccionado: undefined as unknown as MensajeMeeting
    };
  },
  watch: {
    mensajes: {
      handler(nuevo) {
        //this.detalleLocal = { ...nuevo };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    formatDate,
    async fillAcreditado(evento: Evento, hash: string) {
      this.acreditado = await meetingService.findAcreditadoMeetingBy(evento.id, hash);
    },
    async fillMensajes() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      const mensajes: MensajeMeeting[] = await meetingService.findMensajesBy(configuracionMeeting.evento.id, hash);
      this.mensajesFiltrados = mensajes;
    },
    getIcono(item: MensajeMeeting) {
      if (item.fechaLectura) 
      {
        return ['far', 'fa-envelope-open'];
      }
      return ['far', 'fa-envelope'];
    },
    /* Gestión de modal conversacion  */
    async mostrarConversacion(item: MensajeMeeting) {
      this.mensajeSeleccionado = item;
      this.detalleConversacionVisible = true;
    },
    closeDialogConversacion(reload: boolean = false) {
      this.detalleConversacionVisible = false;
      this.mensajeSeleccionado = undefined as unknown as MensajeMeeting;
      try {
        this.isSubmitting = true;
        this.fillMensajes();
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    /* Fin gestión de modal conversacion  */
  },
  async mounted() {
    try {
      this.isSubmitting = true;
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      await this.fillAcreditado(configuracionMeeting.evento, hash);
      await this.fillMensajes();

    } catch (error) {
      this.isSubmitting = false;
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
    } finally {
      this.isSubmitting = false;
    }
  }
});
</script>